import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useSlots } from 'vue'
import { $vfm } from 'vue-final-modal'
import { useCartStore } from '@store/cart'


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonDetails',
  setup(__props) {

const slots = useSlots()

const cartStore = useCartStore()

const openModal = () => {
  if (!cartStore.cartInfo.isDeterminated) return

  $vfm.show({
    component: 'UiModalContainer',
  }, {
    classes: cartStore.cartInfo.quantity ? ['modal--size_xl'] : ['modal--size_sm'],
    component: cartStore.cartInfo.quantity ? 'Modals/Cart/CartView' : 'Modals/Cart/CartEmpty',
  })
}

const render = () => slots.default({
  quantity: cartStore.cartInfo.quantity || 0,
  openModal,
  isDeterminated: cartStore.cartInfo.isDeterminated,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})